module.exports = __webpack_public_path__ + "media/common/images/badges/gray/vseznalek-2b303b97bd7df5aef50b6f5dffaeb751.svg";